import { EventModel } from '@/lib/models/event/types';
import { RouteLinkSegmentEventListApiV4Interface } from '@/types/api-types';

export const transformEvent = (event: RouteLinkSegmentEventListApiV4Interface): EventModel[] => {
  return event;
};
